/** 磨飯金額格式：$41、$41.50、+$7、−$1。整數不帶 .00。 */
export function mfMoney(minor:number,options:{sign?:boolean}={}):string{
  if(!Number.isFinite(minor))return '—';
  const value=minor/100,abs=Math.abs(value);
  const body=Number.isInteger(abs)?abs.toLocaleString('en-HK'):abs.toLocaleString('en-HK',{minimumFractionDigits:2,maximumFractionDigits:2});
  const prefix=value<0?'−':options.sign&&value>0?'+':'';
  return prefix+'$'+body;
}
/** Admin 草稿價錢係字串（元）時用。 */
export const mfMoneyFromDollars=(dollars:string|number)=>mfMoney(Math.round(Number(dollars)*100));
